/* eslint-disable */
export default {
  saveLog: 'Tallenna',
} as const;

// @key: @#@"saveLog"@#@ @source: @#@"Save"@#@
